// src/firebase.js

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyBSqKfKT7FL9G-0yMzLypQM8lIL718mAek",
  authDomain: "ecoach2.firebaseapp.com",
  databaseURL: "https://ecoach2-default-rtdb.firebaseio.com",
  projectId: "ecoach2",
  storageBucket: "ecoach2.firebasestorage.app",
  messagingSenderId: "513742833534",
  appId: "1:513742833534:web:9831a08afb5804c9b3d52f"
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);

export default db;